// Make jQuery and Swiper available globally for modules
export default {
  jQuery: window.jQuery,
  Swiper: window.Swiper,
  $: window.jQuery,
};
